
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Group,
XAddress,
PopupPicker,
XButton
},
name: 'AddressSelect',
data () {
return {
value: [],
showAddress: false,
addressData: ChinaAddressV4Data,
list: [['A', 'B', 'C']],
value5: [],
}
},
methods: {
getImage(id) {
return require(`@/assets/images/${id}.png`);
},
}
}



// WEBPACK FOOTER //
// ./src/pages/AddressSelect.vue